enum DischargeInterestTypeEnum {
    BreakCost = 'BREAK_COST',
    MinimumTerm = 'MINIMUM_TERM',
}

export default DischargeInterestTypeEnum;
